import { Phone, Mail } from "lucide-react";

export const Footer = () => (
    <footer data-testid="footer" className="border-t-2 border-monster-navy bg-monster-navy py-14">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-10 px-5 md:flex-row md:items-center">
            <div className="flex items-center gap-4">
                <img src="/logo.png" alt="Monsters Inflatables logo" className="h-16 w-16 rounded-full border-2 border-white/20 object-cover" />
                <div>
                    <div className="font-display text-xl font-semibold text-white">
                        Monsters <span className="text-monster-green">Inflatables</span>
                    </div>
                    <p className="text-sm font-semibold text-white/50">Bounce house rentals · Genesee County, MI</p>
                </div>
            </div>
            <div className="space-y-2 text-sm font-semibold text-white/70">
                <a href="tel:+18104441076" className="flex items-center gap-2 transition-colors hover:text-monster-yellow">
                    <Phone className="h-4 w-4" /> (810) 444-1076
                </a>
                <a href="mailto:MonstersInflatables@gmail.com" className="flex items-center gap-2 transition-colors hover:text-monster-yellow">
                    <Mail className="h-4 w-4" /> MonstersInflatables@gmail.com
                </a>
            </div>
            <div className="text-sm font-semibold text-white/40">
                <p>© {new Date().getFullYear()} Monsters Inflatables. All rights reserved.</p>
                <a data-testid="footer-admin-link" href="/admin/login" className="mt-1 inline-block transition-colors hover:text-white/70">
                    Owner login
                </a>
            </div>
        </div>
    </footer>
);
